import React from "react";
import unternehmensprofil from "../assets/51.png";
import expertenprofil from "../assets/139.png";
import { useNavigate } from "react-router-dom";
import { useData } from "../util/dataProvider";
import { storage } from "../util/firebase";

export default function NewProfilSelect() {
    const navigate = useNavigate();
    const { unternehmen, experte, profilePicture, companyLogo, assetUrl } =
        useData();
    return (
        <div id='ProfilSelect'>
            <div className='big-title' style={{ marginBottom: "32px" }}>
                Mein bergisch.metall
            </div>
            <div className='container'>
                <div className='left-part'>
                    {unternehmen ? (
                        <div className='select-box'>
                            <div className='small-title'>
                                Unternehmensprofil
                            </div>
                            <img
                                src={companyLogo}
                                style={{ maxHeight: "200px" }}
                            />
                            <div
                                className='btn-grp'
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gridGap: "2rem",
                                }}>
                                <button
                                    onClick={() =>
                                        window.open(
                                            "https://bergisch-metall.de/netzwerk/#/company/" +
                                                unternehmen.id
                                        )
                                    }
                                    className='button-grey'
                                    style={{ width: "100%" }}>
                                    Profil ansehen
                                </button>
                                <button
                                    onClick={() =>
                                        navigate("/unternehmensform")
                                    }
                                    className='button-red'
                                    style={{ width: "100%" }}>
                                    Profil bearbeiten
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className='select-box'>
                            <div className='small-title'>
                                Unternehmensprofil
                            </div>
                            <img
                                style={{ maxHeight: "200px" }}
                                src={assetUrl + unternehmensprofil}
                            />
                            <button
                                className='button-green'
                                onClick={() => navigate("/unternehmensform")}
                                style={{ width: "60%" }}>
                                Profil erstellen
                            </button>
                        </div>
                    )}
                </div>

                <div className='right-part'>
                    {experte ? (
                        <div className='select-box'>
                            <div className='small-title'>
                                Expert*innenprofil
                            </div>
                            <img
                                src={profilePicture}
                                style={{ maxHeight: "200px" }}
                            />
                            <div
                                className='btn-grp'
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gridGap: "2rem",
                                }}>
                                <button
                                    onClick={() =>
                                        window.open(
                                            "https://bergisch-metall.de/netzwerk/#/expert/" +
                                                experte.id
                                        )
                                    }
                                    className='button-grey'
                                    style={{ width: "100%" }}>
                                    Profil ansehen
                                </button>
                                <button
                                    onClick={() => navigate("/expertensform")}
                                    className='button-red'
                                    style={{ width: "100%" }}>
                                    Profil bearbeiten
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className='select-box'>
                            <div className='small-title'>
                                Expert*innenprofil
                            </div>
                            <img
                                style={{ maxHeight: "200px" }}
                                src={assetUrl + expertenprofil}
                            />
                            <button
                                className='button-green'
                                onClick={() => navigate("/expertensform")}
                                style={{ width: "60%" }}>
                                Profil erstellen
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
